import {
  createNativeStackNavigator 
} from '@react-navigation/native-stack';
import React, {useState} from 'react';
import GoBack_btn_copy from '../src/components/Header/goBack';
import {View, Text, Button, Platform, Pressable} from 'react-native';
import WebViewComp from '../src/components/WebView';

function MenuItemScreen({navigation, route}) {
  route = route.params.navProps.route;
  navigation = route.params.navProps ?  route.params.navProps.navigation : navigation;
  var url = route.params.url;
  var siteURL = route.params.siteURL;

  if(url.startsWith("/")){
    url = siteURL + url;
  }

  if (url.includes("?") || url.includes("stripe")){
    console.log("do nothing");
  } else {
    if (url.substr(-1) != '/') {url += '/'}
  }
  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      {
        <View style={[{flex: 1, width: "100%"}]}>
          <WebViewComp 
            siteURL={route.params.siteURL ? route.params.siteURL : route.params.tabNavi.siteURL}
            url={url} 
            navigation={navigation} 
            screenName={"MenuItemInner"} 
            route={route}
            hideThis={route.params.hideThis}
            bottomBarPages={route.params.bottomBarPages}
            loadingColor={route.params.loadingColor}
          />
        </View>
      }
    </View>
  )
}

function MenuItemScreenInner({navigation, route}) {
  //console.log("menu item inner: ", route)
  // console.log(route.params.navProps.route.params);
  var url = route.params.url;
  var siteURL = route.params.siteURL;

  if(url.startsWith("/")){
    url = siteURL + url;
  }

  if (url.includes("?") || url.includes("stripe")){
    console.log("do nothing");
  } else {
    if (url.substr(-1) != '/') {url += '/'}
  }
  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      {
        <View style={[{flex: 1, width: "100%"}]}>
          <WebViewComp 
           siteURL={route.params.siteURL}
           url={url} 
           navigation={navigation} 
           screenName={"MenuItemInner"} 
           route={route}
           hideThis={route.params.hideThis}
           bottomBarPages={route.params.bottomBarPages}
           loadingColor={route.params.loadingColor}
          />
        </View>
      }
    </View>
  )
}

const Navigation = createNativeStackNavigator ();

const ModalNavigation = ({...props}) => {
  let navProps = props;
  // console.log("modal navigation: ", navProps.route.params);
  let title = navProps.route.params.url.replace(/\/+$/, '').split("/").pop().split("?")[0].replace("/", "").replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase());
  return(
    <Navigation.Navigator>
      <Navigation.Group>
        <Navigation.Screen 
          name={"MenuItem"}
          component={MenuItemScreen}
          initialParams={{ navProps: navProps }}
          options={({...props}) => (
            {
            gestureEnabled: true,
            headerShown: true,
            title: title,
            headerTransparent: false,
            headerShadowVisible: false,
            headerStyle: {
              backgroundColor: "white",
            },
            headerTitleAlign: 'center',
            headerLeft: () => <GoBack_btn_copy navigation={props.navigation} color={"black"} />,
          })}
        />
        <Navigation.Screen 
          name={"MenuItemInner"}
          component={MenuItemScreenInner}
          initialParams={{ navProps: navProps }}
          options={({...props}) => ({
            gestureEnabled: true,
            headerShown: true,
            title: props.route.params.url.replace(/\/+$/, '').split("/").pop().split("?")[0].replace("/", "").replace(/-/g, " ").replace(/^\w/, (c) => c.toUpperCase()),
            headerTransparent: false,
            headerShadowVisible: false,
            headerStyle: {
              backgroundColor: "white",
            },
            headerTitleAlign: 'center',
            headerLeft: () => <GoBack_btn_copy navigation={props.navigation} color={"black"} />,
          })}
        />
      </Navigation.Group>
    </Navigation.Navigator>
)};
export default ModalNavigation;
